import script from "./PosPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PosPage.vue?vue&type=script&setup=true&lang=ts"

import "./PosPage.vue?vue&type=style&index=0&id=39fc88c1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39fc88c1"]])

export default __exports__